module.exports = __webpack_public_path__ + "static/media/16.ea426e24.jpg";